import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT =
  "<p>We believe in delivering a holistic learning experience and have designed the programs accordingly for each grade. St. Andrews World School, Siddharth Vihar is widely renowned for its unique school programs effectively divided for each grade. As the student advances, they undergo a journey of continuous learning, exploring their interests, and identifying the right opportunities.</p>\n<p>Our Junior, Middle, and Senior grade programs are distinctively curated to fit the all-around growth of the student. Each program carries our vision of modern schooling education while equally focusing on the interactive and experiential part of learning.</p>";

const OurProgrammesPage = () => {
  const pageData = usePage('our-programmes', { content: DEFAULT_CONTENT });

  const title = 'Our Programmes';

  return (
    <>
      <SEO title={title} description="Our Programmes at St. Andrews World School, Siddharth Vihar." keywords="Our Programmes, SAWS Siddharth Vihar" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || `${process.env.PUBLIC_URL}/images/page-banners/curricullam-infrastructure.jpg`} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default OurProgrammesPage;
